import Vue from 'vue'
import './plugins/axios'
import store from './store'
import VueApollo from 'vue-apollo'
import AWSAppSyncClient from 'aws-appsync'
import Lottie from 'vue-lottie'
import Flag from 'vue-flagpack'
import PortalVue from 'portal-vue'
import {Amplify} from 'aws-amplify'
import Fragment from 'vue-fragment'

// Check app mode — priority: IB > Broker > Trader
const isBrokerStandalone = process.env.VUE_APP_BROKER_STANDALONE === 'true'
const isIBStandalone = process.env.VUE_APP_IB_STANDALONE === 'true'

console.log('App Mode:', isIBStandalone ? 'IB' : isBrokerStandalone ? 'Broker' : 'Trader')

// Add app class to body immediately
if (typeof document !== 'undefined') {
  if (isIBStandalone) {
    document.body.classList.add('ib-app')
  } else if (isBrokerStandalone) {
    document.body.classList.add('broker-app')
  }
}

// Import styles - conditionally load based on app mode
require('@fortawesome/fontawesome-free/css/all.css')
if (isIBStandalone) {
  require('flag-icon-css/css/flag-icons.min.css')
  require('./apps/ib/styles/app.scss')
} else if (isBrokerStandalone) {
  // Import flag styles for broker app
  require('flag-icon-css/css/flag-icons.min.css')
  // Import broker styles ONLY
  require('./apps/broker/styles/app.scss')
} else {
  // Import trader styles ONLY when NOT in broker mode
  require('./global.scss')
}

// Conditionally import App component
const App = isIBStandalone
  ? require('./apps/ib/App.vue').default
  : isBrokerStandalone
    ? require('./apps/broker/App.vue').default
    : require('./App.vue').default

// Conditionally import router
const router = isIBStandalone
  ? require('./apps/ib/router').default
  : isBrokerStandalone
    ? require('./apps/broker/router').default
    : require('./router').default

// Conditionally import i18n
const i18n = isIBStandalone
  ? require('./apps/ib/i18n').default
  : isBrokerStandalone
    ? require('./apps/broker/i18n').default
    : require('./i18n').default

// Import Vuetify
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)

// Create vuetify instance with conditional theme
const vuetify = require('./plugins/vuetify').default

// Conditionally import TranslationHelper for trader app
if (!isBrokerStandalone && !isIBStandalone) {
  const TranslationHelper = require('./mixins/translationHelper').default
  Vue.mixin(TranslationHelper)
}

// Register PortalVue
Vue.use(PortalVue)

// Initialize AWS Amplify library
Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_LKpAkTLn2',
    userPoolWebClientId: '3vr45vnntgtn2du4for24o5438',
  }
})

// Apollo setup for trader app only
let apolloProvider = null
if (!isBrokerStandalone && !isIBStandalone) {
  const config = {
    url: 'https://gxd52tpynfcjbghzu7axjnbbk4.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'us-east-1',
    auth: {
      type: 'AWS_LAMBDA',
      token: '1',
    },
    disableOffline: true
  }

  const options = {
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network'
      }
    }
  }

  const client = new AWSAppSyncClient(config, options)
  apolloProvider = new VueApollo({
    defaultClient: client
  })
  Vue.use(VueApollo)
}

Vue.config.productionTip = false

// Global context flags
Vue.prototype.$isTraderApp = !isBrokerStandalone && !isIBStandalone
Vue.prototype.$isBrokerApp = isBrokerStandalone
Vue.prototype.$isIBApp = isIBStandalone

// Register global components
Vue.component('lottie', Lottie)
Vue.use(Flag, {name: 'Flag'})
Vue.use(Fragment.Plugin)

// Create Vue instance with conditional apollo
const vueOptions = {
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}

// Only add apollo for trader app
if (apolloProvider) {
  vueOptions.apolloProvider = apolloProvider
}

new Vue(vueOptions).$mount('#app')